import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { RootState } from "../store";

const ToastHandler: React.FC = () => {
  const [messageApi, contextHolder] = message.useMessage();

  // selector
  const { error, success } = useSelector((state: RootState) => state.msg);
  // use
  const dispatch = useDispatch();

  // useEffect
  useEffect(() => {
    if (error) {
      messageApi.open({
        type: "error",
        content: error,
        duration: 4,
        style: {
          marginTop: "2vh",
          fontSize: "1.1rem",
          height: "40px",
        },
      });
      dispatch({ type: "CLEAR_TOAST" });
    }
    if (success) {
      messageApi.open({
        type: "success",
        content: success,
        duration: 4,
        style: {
          marginTop: "2vh",
          fontSize: "1.1rem",
          height: "40px",
        },
      });
      dispatch({ type: "CLEAR_TOAST" });
    }
  }, [error, success, dispatch, messageApi]);

  return <>{contextHolder}</>;
};

export default ToastHandler;
